var e = ((n) => (n.development = "development", n.staging = "staging", n.production = "production", n.test = "test", n))(e || {});
function t() {
  return console.log("getEnvironment called, NODE_ENV:", "production"), window.adobeIMS && window.adobeIMS.adobeIdData.environment === "stg1" ? "staging" : "production";
}
const o = () => t() === "development", i = () => t() === "production", s = () => t() === "test";
export {
  e as Environment,
  t as getEnvironment,
  o as isDevelopment,
  i as isProduction,
  s as isTest
};
//# sourceMappingURL=Environment.js.map
